import { useBoolean } from '@qfa/react-components';
import { PropsWithChildren, createContext, useContext } from 'react';

type UserLogoutDialogContextValue = {
  openDialog: () => void;
  closeDialog: () => void;
  logoutDialogOpen: boolean;
};
const UserLogoutDialogContext = createContext<UserLogoutDialogContextValue>({
  openDialog: () => {},
  closeDialog: () => {},
  logoutDialogOpen: false,
});

export const useUserLogoutDialogContext = () => {
  const context = useContext(UserLogoutDialogContext);
  return context;
};

export const UserLogoutDialogContextProvider = ({ children }: PropsWithChildren<{}>) => {
  const [{ off: closeDialog, on: openDialog }, logoutDialogOpen] = useBoolean();

  return (
    <UserLogoutDialogContext.Provider value={{ closeDialog, openDialog, logoutDialogOpen }}>
      {children}
    </UserLogoutDialogContext.Provider>
  );
};
